// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"162":"8478d5629633b82afcd4","781":"e14775a77058fc49bf39"}[chunkId] + ".chunk.js";
};